import { useFadeIn } from '../../../hooks/useFadeIn';

export default function Strengths() {
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  const strengths = [
    {
      icon: 'ri-stethoscope-line',
      title: '医学的・科学的に設計された\nサービス体系',
      features: [
        '精神科専門医が監修する信頼のカウンセリング',
        'エビデンスに基づいたアプローチで安心',
        '医療機関との連携体制も完備'
      ]
    },
    {
      icon: 'ri-hand-heart-line',
      title: '社内担当者との\n密な連携体制',
      features: [
        '産業保健に精通したスタッフによる定期フィードバック',
        '企業様ごとのお悩みに寄り添った解決策の提案',
        '人事担当者の負担を大幅に軽減'
      ]
    },
    {
      icon: 'ri-medal-line',
      title: '厳選された専門家のみが対応',
      features: [
        'カウンセラーは臨床心理士・公認心理師に限定',
        '必要時に医療機関・産業医との連携が可能',
        '継続的な研修による質の維持・向上'
      ]
    }
  ];

  return (
    <section className="min-h-[75vh] py-24 bg-gradient-to-br from-[#F0F8FB] to-[#E8F4F8] relative overflow-hidden flex items-center">
      {/* Decorative Circle */}
      <div className="absolute right-0 top-1/4 w-96 h-96 bg-[#4A7BA7]/10 rounded-full blur-3xl"></div>

      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 w-full relative transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A3B5C] mb-4">
            選ばれる3つの理由
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {strengths.map((strength, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-700 group cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="mb-6 flex justify-center">
                <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className={`${strength.icon} text-4xl text-[#1A3B5C]`}></i>
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-[#1A3B5C] mb-6 text-center leading-tight whitespace-pre-line min-h-[3.5rem]">
                {strength.title}
              </h3>
              
              <ul className="space-y-4">
                {strength.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="mt-1 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#FF6B6B] text-lg"></i>
                    </div>
                    <span className="text-sm text-gray-700 leading-relaxed">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
